export default "__VITE_ASSET__yyE8MJmL__"